import './assets/main.css'

import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {App} from './App'
import {initializeGoogleTag} from './services/googleTag'
import {capturePostHogException, initializePostHog} from './services/posthog'
import {initializeTheme} from './stores/theme_mode'

initializeTheme()
const idleCallback = (window as Window & {
  requestIdleCallback?: (callback: () => void, options?: {timeout: number}) => number
}).requestIdleCallback

if (idleCallback !== undefined) {
  idleCallback(() => {
    initializePostHog()
    initializeGoogleTag()
  }, {timeout: 2000})
} else {
  window.setTimeout(() => {
    initializePostHog()
    initializeGoogleTag()
  }, 0)
}

console.log('env', import.meta.env.VITE_APP_ENV)

const mountElement = document.getElementById('app')

if (mountElement === null) {
  throw new Error('Unable to find the application mount element')
}

const captureReactError = (error: unknown, errorInfo: {componentStack?: string}): void => {
  capturePostHogException(error, {
    component_stack: errorInfo.componentStack,
  })
}

createRoot(mountElement, {
  onUncaughtError: (error, errorInfo) => captureReactError(error, errorInfo),
  onCaughtError: (error, errorInfo) => captureReactError(error, errorInfo),
  onRecoverableError: (error, errorInfo) => captureReactError(error, errorInfo),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
